import { MetricName, ReliabilityMetrics } from '@canvas/frontend-metrics';

export type CloseConnectTimeGapNcsOutcome = 'no_status' | 'no_gap' | 'gap_closed';

function getErrorMessage(err: unknown) {
  return err instanceof Error ? err.message : String(err);
}

export class CloseConnectTimeGapNcsMetrics {
  private readonly startedAt = Date.now();

  success(outcome: CloseConnectTimeGapNcsOutcome) {
    ReliabilityMetrics.getInstance().successWithDuration(
      MetricName.CLOSE_CONNECT_TIME_GAP_NCS,
      this.startedAt,
      Date.now(),
      { outcome },
    );
  }

  failure(err: unknown) {
    ReliabilityMetrics.getInstance().failureWithDuration(
      MetricName.CLOSE_CONNECT_TIME_GAP_NCS,
      this.startedAt,
      Date.now(),
      { errorMessage: getErrorMessage(err) },
    );
  }
}

export class GetDocumentStatusNcsMetrics {
  private readonly startedAt = Date.now();

  success() {
    ReliabilityMetrics.getInstance().successWithDuration(
      MetricName.GET_DOCUMENT_STATUS_NCS,
      this.startedAt,
      Date.now(),
    );
  }

  failure(err: unknown) {
    ReliabilityMetrics.getInstance().failureWithDuration(
      MetricName.GET_DOCUMENT_STATUS_NCS,
      this.startedAt,
      Date.now(),
      { errorMessage: getErrorMessage(err) },
    );
  }
}
